import { render, staticRenderFns } from "./ModernSelectBox.vue?vue&type=template&id=674eb3f2&scoped=true&"
import script from "./ModernSelectBox.vue?vue&type=script&lang=js&"
export * from "./ModernSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674eb3f2",
  null
  
)

export default component.exports